import React, { useState, useEffect } from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios'
import {
  IoIosRadioButtonOff,
  IoIosRadioButtonOn,
  IoMdEye,
  IoIosAttach,
  IoIosArrowBack,
} from 'react-icons/io'
import Header3 from './components/Header3'
import ClipLoader from 'react-spinners/ClipLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { BiMenu, BiX } from 'react-icons/bi'
import { SiX } from 'react-icons/si'
import { BsFacebook, BsInstagram, BsTiktok, BsWhatsapp } from 'react-icons/bs'
import { RiFacebookLine } from 'react-icons/ri'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import Header5 from './components/Header5'
import { IoWarningOutline } from 'react-icons/io5'
import { API_URL } from './config'

const Marketing = () => {
  const history = useHistory()
  const [saveBtn, setSaveBtn] = useState('save-btn')
  const [disabled, setDisabled] = useState(false)
  const [x, setX] = useState('#')
  const [instagram, setInstagram] = useState('#')
  const [facebook, setFacebook] = useState('#')
  const [whatsapp, setWhatsapp] = useState('#')
  const [tiktok, setTiktok] = useState('#')
  const [text, setText] = useState('')
  const [subject, setSubject] = useState('')
  const [count, setCount] = useState(0)
  const [countColor, setCountColor] = useState('countColor')
  const [phone, setPhone] = useState('')
  const [businessEmail, setBusinessEmail] = useState('')
  const [optionOne, setOptionOne] = useState(
    localStorage.getItem('type') == 'SMS' ? 'item-select-active' : 'item-select'
  )
  const [optionTwo, setOptionTwo] = useState(
    localStorage.getItem('type') == 'EMAIL' ? 'item-select-active' : 'item-select'
  )

  const [offRadioOne, setOffRadioOne] = useState(
    localStorage.getItem('type') == 'SMS' ? false : true
  )
  const [onRadioOne, setOnRadioOne] = useState(localStorage.getItem('type') == 'SMS' ? true : false)

  const [offRadioTwo, setOffRadioTwo] = useState(
    localStorage.getItem('type') == 'EMAIL' ? false : true
  )
  const [onRadioTwo, setOnRadioTwo] = useState(
    localStorage.getItem('type') == 'EMAIL' ? true : false
  )

  const [marketingType, setMarketingType] = useState(localStorage.getItem('type'))

  const [recipients, setRecipients] = useState(localStorage.getItem('audience'))

  const [alias, setAlias] = useState(localStorage.getItem('alias'))

  const [attachment, setAttachment] = useState('')
  const [attachmentLabel, setAttachmentLabel] = useState('Add attachment')

  const [removeImage, setRemoveImage] = useState('')
  const [showAttach, setShowAttach] = useState(true)

  const [presAttachment, setPreAttachment] = useState('')
  const [attachmentName, setAttachmentName] = useState('')
  const [type, setType] = useState('')
  const [path, setPath] = useState('')

  const [loadLabel, setLoadLabel] = useState(true)
  const [loadCliper, setLoadCliper] = useState(false)

  const [errorDisplay, setErrorDisplay] = useState('none')
  const [error, setError] = useState('')

  const [active, setActive] = useState(1)

  const [responsebg, setResponseBG] = useState('error-login')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = 'Marketing campaign'

    const businessid = localStorage.getItem('businessid')

    axios
      .get(`${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS`, {
        withCredentials: true,
      })
      .then((response) => {
        setPhone(response.data.phone)
        setBusinessEmail(response.data.email)
        setX(response.data.twitter)
        setInstagram(response.data.instagram)
        setFacebook(response.data.facebook)
        setTiktok(response.data.tiktok)
      })
      .catch((error) => {
        alert(error)
      })

    if (localStorage.getItem('alias') == 'NEWAUDIENCE') {
      axios
        .get(
          `${API_URL}/apps/kscanner/webservices.php?query=GET-AUDIENCE-COUNT&businessid=${businessid}`,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          setRecipients(response.data.audience)
        })
        .catch((error) => {
          alert(error)
        })
    }
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  async function next() {
    setLoadLabel(false)
    setLoadCliper(true)

    setErrorDisplay('none')
    setActive(1)

    const businessid = localStorage.getItem('businessid')

    const cost = recipients.replace(',', '') * 0.9

    const data = new FormData()
    data.append('file', attachment)
    data.append('businessid', businessid)
    data.append('text', text) // Text from the texarea
    data.append('subject', subject) // Subject from the input type
    data.append('subqueryone', marketingType) // SMS OR EMAIL
    data.append('marketing_type', marketingType) // SMS OR EMAIL
    data.append('subquerytwo', alias) // EXISTINGAUDIENCE, DATABASE OR NEWAUDIENCE
    data.append('query', 'EMAIL-MARKETING') // MARKETING
    data.append('recipients_count', recipients.replace(',', ''))
    data.append('cost', cost)

    if (marketingType === 'EMAIL' && subject.trim() === '') {
      setErrorDisplay('block')
      setError('Enter email subject')
      setResponseBG('error-login')
      setLoadLabel(true)
      setLoadCliper(false)
    } else {
      setSaveBtn('btn-disabled')
      setDisabled(true)
      await axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data: data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((response) => {
        setSaveBtn('save-btn')
        setDisabled(false)
        if (marketingType === 'EMAIL') {
          if (response.data.status === 'success') {
            setErrorDisplay('block')
            setError(response.data.message)
            setResponseBG('success-login')
          } else {
            setErrorDisplay('block')
            setError(response.data.message)
            setResponseBG('error-login')
          }
        } else {
          // sms marketing
          //   alert(response.data.textid);
          localStorage.setItem('textid', response.data.textid)
          const cost = Number(recipients) * 0.9
          history.push({
            pathname: '/smscampaign',
            state: {
              textid: response.data.textid,
              alias: alias,
              audience: recipients,
              cost: cost,
              text: text,
              business_email: businessEmail,
            },
          })
        }
        setSaveBtn('save-btn')
        setDisabled(false)
        setLoadLabel(true)
        setLoadCliper(false)

        //   setActive(0);
      })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
    }
  }

  function handleText(event) {
    setText(event.target.value)
    setCount(event.target.value.length)
    if (event.target.value.length > 130) {
      setCountColor('countColor-error')
    } else {
      setCountColor('countColor')
    }
  }

  function handleSubject(event) {
    setSubject(event.target.value)
  }

  function email() {
    setOptionOne('item-select')
    setOptionTwo('item-select-active')

    setOffRadioOne(true)
    setOnRadioOne(false)

    setOffRadioTwo(false)
    setOnRadioTwo(true)
    setMarketingType('EMAIL')

    setShowAttach(false)
    setAttachmentLabel('Add attachment')
    setAttachment('')
    setErrorDisplay('none')
    setActive(1)
  }

  function sms() {
    setOptionTwo('item-select')
    setOptionOne('item-select-active')

    setOffRadioTwo(true)
    setOnRadioTwo(false)

    setOffRadioOne(false)
    setOnRadioOne(true)
    setMarketingType('SMS')

    setErrorDisplay('none')
    setActive(1)
  }

  function removeAttachment() {
    setShowAttach(false)
    setAttachmentLabel('Add attachment')
    setAttachment('')
    setErrorDisplay('none')
    setActive(1)
  }

  function selectImage(event) {
    const img = event.target.files[0]
    setAttachment(event.target.files[0])
    setPreAttachment(URL.createObjectURL(event.target.files[0]))
    setAttachmentName(img.name)
    setType(img.type)
    setPath(URL.createObjectURL(event.target.files[0]))
    setShowAttach(true)

    setAttachmentLabel('Change attachment')
    setRemoveImage(
      <label className="mt-3 color-red hover-text" onClick={removeAttachment}>
        <i>Remove attachment</i>
      </label>
    )

    setErrorDisplay('none')
    setActive(1)
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  } else {
    if (localStorage.getItem('alias') === null) {
      return <Redirect to="/sms" />
    }
  }

  function formatPhoneLocal(phoneNumber) {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
  }
  const businessname = localStorage.getItem('businessname')
  const businessid = localStorage.getItem('businessid')
  //   alert(recipients.replace(",", ""));
  const total = recipients < 1000 ? recipients * 0.9 : recipients.replace(',', '') * 0.9

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  const accounttype = localStorage.getItem('accounttype')

  return (
    <div className="view">
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : (
        <Header5 />
      )}

      <div
        className="container p-3"
        style={{
          marginTop: 20,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : '240px',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-6 mt-0 pl-2 pr-2">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-12 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer mb-5 pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-top-header">
                  <div className="col-12">
                    <label class="back-arrow float-right">
                      {/* localStorage.getItem("type") !== "EMAIL" */}
                      <button
                        type="button"
                        class={
                          text.trim() === '' || (count > 130 && marketingType == 'SMS')
                            ? 'btn-disabled text-bold'
                            : saveBtn + ' text-bold'
                        }
                        onClick={next.bind(this)}
                        disabled={
                          text.trim() === '' || (count > 130 && marketingType == 'SMS')
                            ? true
                            : false
                        }
                      >
                        {loadLabel && (marketingType == 'SMS' ? 'Proceed' : 'Send')}
                        {loadCliper && <ClipLoader color={'grey'} loading={true} size={20} />}
                      </button>
                    </label>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
                <div className="row w-100">
                  <div className="col-12 text-left pl-3 pr-3 pb-3 pt-0">
                    <span>Choose communication</span>
                  </div>
                  {localStorage.getItem('type') == 'EMAIL' &&
                  localStorage.getItem('alias') == 'NEWAUDIENCE' ? (
                    ''
                  ) : (
                    <div className="col-lg-6 col-sm-6 pr-0">
                      <div className={optionOne} onClick={sms}>
                        <div className="w-100 menu-links">
                          <div className="col-1 col-lg-2 text-left">
                            {onRadioOne && <IoIosRadioButtonOn size={28} color={'#66b266'} />}
                            {offRadioOne && <IoIosRadioButtonOff size={28} color={'#b2b200'} />}
                          </div>
                          <div className="col-11 col-lg-10">
                            <label className="item-names w-100">SMS</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {localStorage.getItem('type') == 'SMS' &&
                  localStorage.getItem('alias') == 'NEWAUDIENCE' ? (
                    ''
                  ) : (
                    <div className="col-lg-6 col-sm-6 pr-0">
                      <div className={optionTwo} onClick={email}>
                        <div className="w-100 menu-links">
                          <div className="col-1 col-lg-2 text-left">
                            {onRadioTwo && <IoIosRadioButtonOn size={28} color={'#66b266'} />}
                            {offRadioTwo && <IoIosRadioButtonOff size={28} color={'#b2b200'} />}
                          </div>

                          <div className="col-11 col-lg-10">
                            <label className="item-names w-100">Email</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-12 text-left p-3">
                  {/* <span>
                    {marketingType === "SMS"
                      ? "Your text is limited to 130 characters — the remaining 30 are reserved for personalized names."
                      : "Character limit deactivated"}
                  </span> */}

                  <span>{marketingType === 'SMS' ? '' : 'Character limit deactivated'}</span>
                </div>

                <div className={marketingType == 'SMS' ? 'd-none' : 'col-12 text-left pt-0 pb-0'}>
                  {marketingType === 'SMS' ? (
                    ''
                  ) : (
                    <input
                      type="text"
                      placeholder={'Email subject'}
                      onChange={handleSubject}
                      value={subject}
                      className="edit-input mb-3"
                    />
                  )}
                  <label className="text-grey">
                    Just write your {marketingType == 'SMS' ? 'text' : 'email message'}—no need for
                    greetings. Karamale will automatically add them for you.
                  </label>
                  <textarea
                    placeholder={
                      marketingType == 'SMS' ? 'Type your text message' : 'Type your email message'
                    }
                    onChange={handleText}
                    value={text}
                    className="color-black"
                    style={{ height: marketingType == 'SMS' ? 100 : 350 }}
                  />
                  {marketingType === 'EMAIL' ? (
                    <label className="color-blue" htmlFor="image">
                      <IoIosAttach size={20} /> {attachmentLabel}
                    </label>
                  ) : (
                    <label className="color-light-grey">
                      <IoIosAttach size={20} /> Add attachment
                    </label>
                  )}
                  <label className="float-right">
                    {marketingType === 'EMAIL' ? (
                      <label className="w-100">
                        <label>No character limit</label>
                      </label>
                    ) : (
                      <label>
                        <label className={countColor}>{count}</label> / 130
                      </label>
                    )}
                  </label>
                </div>
                <div className={marketingType == 'SMS' ? 'col-12 text-grey text-left' : 'd-none'}>
                  <label className="text-center w-100">
                    <IoWarningOutline size={100} />
                  </label>
                  SMS communications are temporarily offline. Kindly direct all communication via
                  email.
                </div>
                <div className={marketingType == 'SMS' ? 'd-none' : 'col-12'}>
                  <span>
                    {recipients} {recipients == 1 ? ' recipient' : ' recipients'} will receive the{' '}
                    {marketingType === 'SMS' ? 'text' : 'email'}
                  </span>
                  <label className="w-100">
                    {marketingType === 'SMS' ? (
                      <label className="w-100">
                        <label className="color-grey">R0.90 per recipient</label>{' '}
                        <label className="float-right">
                          <span>Total</span>:{' '}
                          <label className="color-grey">R{total.toFixed(2)}</label>
                        </label>
                      </label>
                    ) : (
                      <label className="w-100">
                        <label className="color-grey">Email marketing is free</label>{' '}
                        <label className="float-right">
                          <span>Total</span>: <label className="color-grey">R0.0</label>
                        </label>
                      </label>
                    )}
                  </label>
                  <input
                    name="file"
                    type="file"
                    onChange={selectImage}
                    id="image"
                    className="hide-file-input-type"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-5  pl-2 pr-2">
            <div className=" BoxDashboardContainer mb-5 pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-top-header">
                  <div className="col-lg-1 col-2 col-sm-1 text-center pt-1">
                    <IoMdEye size={30} />
                  </div>
                  <div className="col-lg-11 col-10 col-sm-11">
                    <label className=" pt-2">
                      <span>Preview</span>
                    </label>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
                <div className="col-12 text-left pb-0">
                  <label className="pre-line">
                    {text.trim() === '' ? (
                      <label className="color-grey">
                        Your text will appear here the moment you start typing
                      </label>
                    ) : (
                      <label>
                        <div className="row">
                          <div
                            className={
                              marketingType == 'SMS' ? 'd-none' : 'col-12 text-center mt-3'
                            }
                          >
                            <img src={`${API_URL}/karamale.png`} width="150" />
                          </div>
                          <div className="col-12 mt-4">Hi [Name],</div>

                          <div className="col-12 mt-3">
                            <label className=" pre-line">{text}</label>
                          </div>
                          <div className={marketingType == 'SMS' ? 'd-none' : 'col-12 mt-3'}>
                            <span> Contact:</span> {formatPhoneLocal(phone)}
                            <br />
                            <span> Email:</span> {businessEmail}
                          </div>
                          <div className={marketingType == 'SMS' ? 'd-none' : 'col-12 mt-3'}>
                            Warm regards, <br />
                            <span>{businessname}</span>
                          </div>
                          <div
                            className={
                              marketingType == 'SMS'
                                ? 'd-none'
                                : 'col-12 mt-3 col-12 mt-3 text-center mt-4'
                            }
                          >
                            <label className="text-grey">Follow {businessname}</label>
                            <br />
                            <label>
                              <a href={x} target={x == '#' ? '' : '_blank'}>
                                <SiX size={25} color="#000000" />
                              </a>
                              &nbsp;{' '}
                              <a target={instagram == '#' ? '' : '_blank'} href={instagram}>
                                <BsInstagram size={25} color={'#d62976'} />
                              </a>
                              &nbsp;&nbsp;
                              <a target={facebook == '#' ? '' : '_blank'} href={facebook}>
                                <BsFacebook size={25} color="#1877F2" />
                              </a>
                              &nbsp;&nbsp;
                              <a target={tiktok == '#' ? '' : '_blank'} href={tiktok}>
                                <BsTiktok size={25} color="#25F4EE" />
                              </a>
                            </label>
                            <br />
                            <br />
                            <label className="text-grey">
                              This email was sent by Karamale on behalf of
                              <br />
                              {businessname}
                            </label>
                          </div>
                        </div>
                      </label>
                    )}
                    {marketingType === 'EMAIL' ? (
                      <label>
                        {showAttach && (
                          <label>
                            {type == 'application/pdf' ? (
                              <label className="w-100">
                                <label className="w-100">
                                  <img
                                    src={`${API_URL}/apps/kscanner/icons/pdf.png`}
                                    width={100}
                                    className="mr-3"
                                    alt="Attachment"
                                  />
                                </label>

                                {attachmentName}
                                <br />
                                {removeImage}
                              </label>
                            ) : type ==
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
                              <label className="w-100">
                                <label className="w-100">
                                  <img
                                    src={`${API_URL}/apps/kscanner/icons/word.png`}
                                    width={100}
                                    className="mr-3"
                                    alt="Attachment"
                                  />
                                </label>

                                {attachmentName}
                                <br />
                                {removeImage}
                              </label>
                            ) : type == 'application/vnd.ms-excel' ? (
                              <label className="w-100">
                                <label className="w-100">
                                  <img
                                    src={`${API_URL}/apps/kscanner/icons/excel.png`}
                                    width={100}
                                    className="mr-3"
                                    alt="Attachment"
                                  />
                                </label>

                                {attachmentName}
                                <br />
                                {removeImage}
                              </label>
                            ) : type == 'image/png' || type == 'image/jpeg' ? (
                              <label className="w-100">
                                <img src={presAttachment} className="w-100" alt="Attachment" />
                                {removeImage}
                              </label>
                            ) : type == 'audio/mpeg' ? (
                              <label className="w-100">
                                {type.trim() !== '' ? (
                                  <label>
                                    <label className="w-100">
                                      <img
                                        src={`${API_URL}/apps/kscanner/icons/mp3.png`}
                                        width={100}
                                        className="mr-3"
                                        alt="Attachment"
                                      />
                                    </label>
                                    {attachmentName}
                                    <br />
                                    {removeImage}
                                  </label>
                                ) : (
                                  ''
                                )}
                              </label>
                            ) : type == 'video/mp4' ? (
                              <label className="w-100">
                                {type.trim() !== '' ? (
                                  <label>
                                    <label className="w-100">
                                      <img
                                        src={`${API_URL}/apps/kscanner/icons/mp4.png`}
                                        width={100}
                                        className="mr-3"
                                        alt="Attachment"
                                      />
                                    </label>
                                    {attachmentName}
                                    <br />
                                    {removeImage}
                                  </label>
                                ) : (
                                  ''
                                )}
                              </label>
                            ) : (
                              <label className="w-100">
                                {type.trim() !== '' ? (
                                  <label>
                                    <label className="w-100">
                                      <img
                                        src={`${API_URL}/apps/kscanner/icons/file.png`}
                                        width={100}
                                        className="mr-3"
                                        alt="Attachment"
                                      />
                                    </label>
                                    {attachmentName}
                                    <br />
                                    {removeImage}
                                  </label>
                                ) : (
                                  ''
                                )}
                              </label>
                            )}
                          </label>
                        )}
                      </label>
                    ) : (
                      ''
                    )}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={responsebg + ' text-center'} style={{ display: errorDisplay }}>
        {error}
      </div>
    </div>
  )
}

export default Marketing
